__webpack_require__.p = "/tax-revenue-by-income-quintile/";